import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yfggtce42d: FaireBrandEntity = {
  token: "b_yfggtce42d",
  type: "brand",
  name: "Oblige by G",
  avatarUrl:
    "https://cdn.faire.com/fastly/25e236dc25f0949b82c43607ac88760101d7bea7cec2155b119ea146a6243140.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a97e0ccb67eac26a07132c1a5dfce41608173458f47410601292e72e24bf2a03.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/25e236dc25f0949b82c43607ac88760101d7bea7cec2155b119ea146a6243140.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a97e0ccb67eac26a07132c1a5dfce41608173458f47410601292e72e24bf2a03.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "obligebyg is a women’s fashion and accessories brand designed to add a touch of confidence to everyday life.\nWith timeless elegance and subtle details inspired by modern trends, our collections bring a sense of refinement to daily style.\n\nWe believe clothing and accessories are more than just fashion items  they are a language of self-expression.\nEach piece from obligebyg carries a warm yet sophisticated spirit, becoming a promise to help you preserve your unique aura, even in the busiest of days.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:52.810Z",
    importedBy: "entity-db-cli",
  },
};
